module.exports = __webpack_public_path__ + "static/media/39.466bd7dc.mp3";